import React from 'react';
import { useIntl } from 'react-intl';
import {
  Card, CardBody, CardFooter, CardHeader, Col,
  FormGroup, Row,
} from 'reactstrap';
import styled from 'styled-components';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';

const Shimmer = styled.span.attrs({
  className: 'placeholder placeholder-glow bg-darken',
})`
  height: ${(props) => props.height || '1rem'};
  width: ${(props) => props.width || '100%'};
  display: inline-block;
  border-radius: 0.25rem;
`;

/**
 * Placeholder component that displays a loading skeleton for the
 * TradeRuleProposalNominatedGeneralised page.
 * Renders real breadcrumb and heading text, with shimmer skeletons for async form content.
 * @returns {React.ReactElement} - TradeRuleProposalNominatedGeneralisedPlaceholder component
 */
function TradeRuleProposalNominatedGeneralisedPlaceholder() {
  const intl = useIntl();

  const breadcrumbs = [
    {
      name: intl.formatMessage({ id: 'trade_rule.trade_rule_proposal_nominated_generalised.placeholder.breadcrumbs.trade_rules.label', defaultMessage: 'Trade Rules' }),
      path: '/trade-rules',
    },
    {
      name: intl.formatMessage({ id: 'trade_rule.trade_rule_proposal_nominated_generalised.placeholder.breadcrumbs.propose_peer_to_peer_trade_rule.label', defaultMessage: 'Propose peer-to-peer trade rule' }),
    },
  ];

  const pageTitle = intl.formatMessage({ id: 'trade_rule.trade_rule_proposal_nominated_generalised.placeholder.trade_rule_propose_peer_to_peer.heading', defaultMessage: 'Trade rule - Propose Peer-to-Peer' });

  return (
    <div aria-hidden="true" inert>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <h1 className="mb-4">{pageTitle}</h1>

      <Card>
        <CardHeader className="d-flex flex-wrap align-items-center" style={{ padding: '0.75rem 1.25rem' }}>
          <h2 className="mb-0" style={{ fontSize: '1.25rem' }}>
            {intl.formatMessage({ id: 'trade_rule.trade_rule_proposal_nominated_generalised.flat_pricing_form.propose_peer_to_peer_trade.heading.label', defaultMessage: 'Propose a peer-to-peer trade' })}
          </h2>
          <div className="ms-auto">
            <Shimmer width="8rem" height="2.25rem" />
          </div>
        </CardHeader>
        <CardBody style={{ padding: '1.25rem' }}>
          <FormGroup className="mb-3">
            <Shimmer height="2.5rem" />
          </FormGroup>

          <FormGroup className="mb-3">
            <Shimmer height="2.5rem" />
          </FormGroup>

          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Shimmer height="2.5rem" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Shimmer height="2.5rem" />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="d-flex" style={{ padding: '0.75rem 1.25rem' }}>
          <div className="me-2">
            <Shimmer width="6rem" height="2.25rem" />
          </div>
          <div>
            <Shimmer width="6rem" height="2.25rem" />
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}

export default TradeRuleProposalNominatedGeneralisedPlaceholder;
